import { useEffect, useState } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import actions from '@store/actions/listingSearchPage';
import { useTranslation, Trans } from 'react-i18next';
import { OnlyInMobile, OnlyInDesktopTablet, CustomIcon } from '@components/shared';
import Checkbox from '@components/shared/forms/RawCheckbox';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import { ListingSearchFilterTypes } from '@root/types';
import { Tooltip } from 'antd';
import useHighlightedClick from '../useHighlightedClick';
import s from './FirstToMarketFilter.module.less';

type Props = {
  criteria: ListingSearchCriteria;
  onChange: (criteria: ListingSearchCriteria) => void;
  type?: ListingSearchFilterTypes;
};

const FirstToMarketFilter = ({ criteria, onChange, type = 'quick' }: Props) => {
  const { t } = useTranslation('filters');

  const [firstToMarket, setFirstToMarket] = useState(criteria.exclusive());
  useEffect(() => {
    setFirstToMarket(criteria.exclusive());
  }, [criteria]);

  const { setHighlighted, isHighlighted } = useHighlightedClick();

  const dispatch = useDispatch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    setHighlighted('firstToMarket');
    criteria.changeExclusivity(checked);
    setFirstToMarket(checked);
    dispatch(actions.filterFirstToMarketChanged(checked));
    onChange(criteria);
  };

  return (
    <ul className={classnames(s.firstToMarketContainer)}>
      <li
        className={classnames(s.firstToMarketContent, {
          [s.highlighted]: isHighlighted('firstToMarket'),
        })}
      >
        <Checkbox
          onChange={handleChange}
          checked={firstToMarket}
          name={`truva-exclusive-filter-${type}`}
        >
          <OnlyInDesktopTablet>
            <Tooltip
              overlayClassName={s.tooltip}
              trigger="hover"
              placement="bottomLeft"
              title={t('exclusiveTooltip')}
            >
              <div className={s.exclusiveFilter}>
                <div className={s.icon}>
                  <CustomIcon type="vts-logo-indigo" />
                </div>
                <span className={s.exclusiveLabel}>{t('filters:exclusive')}</span>
              </div>
            </Tooltip>
          </OnlyInDesktopTablet>
          <OnlyInMobile>
            <span className={s.exclusiveIcon}>
              <CustomIcon type="vts-logo-indigo" />
            </span>
            {/* eslint-disable react/jsx-no-literals */}

            <Trans i18nKey="listingSearch:filters.exclusiveMobile">
              <span className={s.exclusiveBold}>First to Market</span>{' '}
              <div className={s.exclusiveDescription}>Spaces only available on VTS Marketplace</div>
            </Trans>
            {/* eslint-enable react/jsx-no-literals */}
          </OnlyInMobile>
        </Checkbox>
      </li>
    </ul>
  );
};

export default FirstToMarketFilter;
